/*global process*/
import React, { useEffect, lazy, Suspense } from "react";
import "./MainRouter.css";
import MainRouterContexts from "./MainRouterContexts";
import { ECLLoader } from "../eclComponents/";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import MainHeader from "../pages/components/MainHeader/MainHeader";
import { testingRoutes } from "./routes/TestingRoutes";
import { sandboxRoutes } from "./routes/SandboxRoutes";
//SOURCEONE MAIN COMPONENTS
const MainHomePage = lazy(
   () => import("../pages/main/MainHomePage/MainHomePage"),
);
const ApplicationViewer = lazy(
   () => import("../pages/main/ApplicationViewer/ApplicationViewer"),
);
const ApplicationPage = lazy(
   () => import("../pages/main/ApplicationPage/ApplicationPage"),
);
const UserSettings = lazy(
   () => import("../pages/main/UserSettings/UserSettings"),
);
const AboutPage = lazy(() => import("../pages/main/AboutPage/AboutPage"));

export default function MainRouter() {
   const navigate = useNavigate();

   useEffect(() => {
      //Check for a url parameter, which will hold a redirect we want to use after getting into app/logging in
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const redirect = urlParams.get("url");
      urlParams.delete("url"); //Remove redirection url
      navigate({
         pathname: redirect,
         search: "?" + urlParams.toString(),
      });
   }, []);

   return (
      <MainRouterContexts>
         <div className="main-layout-flex-container">
            <MainHeader />
            <div className="main-router-main">
               <Routes>
                  {/* SourceOne Main */}
                  <Route
                     exact
                     path="/sourceone"
                     element={
                        <Suspense fallback={<ECLLoader />}>
                           {/* <SourceOneMainRoute> */}
                           <MainHomePage />
                           {/* </SourceOneMainRoute> */}
                        </Suspense>
                     }
                  />
                  <Route
                     exact
                     path="/sourceone/applications"
                     element={
                        <Suspense fallback={<ECLLoader />}>
                           {/* <SourceOneMainRoute> */}
                           <ApplicationPage />
                           {/* </SourceOneMainRoute> */}
                        </Suspense>
                     }
                  />
                  <Route
                     exact
                     path="/sourceone/applications/app/:appId"
                     element={
                        <Suspense fallback={<ECLLoader />}>
                           {/* <SourceOneMainRoute> */}
                           <ApplicationViewer />
                           {/* </SourceOneMainRoute> */}
                        </Suspense>
                     }
                  />
                  <Route
                     exact
                     path="/sourceone/settings"
                     element={
                        <Suspense fallback={<ECLLoader />}>
                           {/* <SourceOneMainRoute> */}
                           <UserSettings />
                           {/* </SourceOneMainRoute> */}
                        </Suspense>
                     }
                  />
                  <Route
                     exact
                     path="/sourceone/about"
                     element={
                        <Suspense fallback={<ECLLoader />}>
                           {/* <SourceOneMainRoute> */}
                           <AboutPage />
                           {/* </SourceOneMainRoute> */}
                        </Suspense>
                     }
                  />
                  {process.env.BUILD !== "production" && ( //don't show the following routes on production builds
                     <>
                        {/* Sandbox Panel*/}
                        {sandboxRoutes}

                        {/* TESTING PANEL */}
                        {testingRoutes}
                     </>
                  )}
                  <Route
                     path="/sourceone/*"
                     element={<Navigate to="/sourceone/" />}
                  />
               </Routes>
            </div>
         </div>

         <div id="drop-down-portal"></div>
         <div id="ECLModal" role="alertdialog"></div>
         <div id="drop-down-in-modal-portal"></div>
      </MainRouterContexts>
   );
}
